import { render, staticRenderFns } from "./toggle-call.vue?vue&type=template&id=327bc723&"
import script from "./toggle-call.vue?vue&type=script&lang=js&"
export * from "./toggle-call.vue?vue&type=script&lang=js&"
import style0 from "./toggle-call.vue?vue&type=style&index=0&id=327bc723&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports